// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"styles_loadingOverlay__PZV+t","spin":"styles_spin__LT6Ud"};